import React, { useEffect, useState } from "react";
import "../BrandPartnershipComponent/BrandPartnershipComponent.css";
import { CiCircleCheck } from "react-icons/ci";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundForward } from "react-icons/io";
import { IoIosArrowRoundBack } from "react-icons/io";
import { RxCross1 } from "react-icons/rx";
import { IoLocationOutline } from "react-icons/io5";
import { PiMedalLight } from "react-icons/pi";
import { TbSpeakerphone } from "react-icons/tb";
import { IoNewspaperOutline } from "react-icons/io5";
import { FaRegEye } from "react-icons/fa";
import { LuBookUser } from "react-icons/lu";
import { PiPencilDuotone } from "react-icons/pi";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import { SiOpencollective } from "react-icons/si";
import { TiFlashOutline } from "react-icons/ti";
import { TbBrandCampaignmonitor } from "react-icons/tb";
import { MdGamepad } from "react-icons/md";
import { HiOutlineLinkSlash } from "react-icons/hi2";
import { FaPodcast } from "react-icons/fa6";
import { TiHomeOutline } from "react-icons/ti";
import { IoSchoolOutline } from "react-icons/io5";
import { LuSchool } from "react-icons/lu";
import { CiCircleInfo } from "react-icons/ci";
import Loader from "../Loader/Loader";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { FiInstagram } from "react-icons/fi";
import { CiFacebook } from "react-icons/ci";
import { FiYoutube } from "react-icons/fi";
import { FiTwitter } from "react-icons/fi";
import { AiOutlineTikTok } from "react-icons/ai";

const BrandPartnershipComponent = () => {
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [playerDetails, setPlayerDetails] = useState(null);

  const [playerFirstName, setPlayerFirstName] = useState(null);
  const [athleteProfileData, setAthleteProfileData] = useState();

  const defaultValueFan = [
    "$1000+",
    "$1500+",
    "$2500+",
    "$1500+",
    "$2000+",
    "$1500+",
    "$1500+",
    "$1500+",
    "$1500+",
    "$1000+",
    "$2000+",
  ];
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    outline: "none",
  };
  const [selectedExperience, setSelectedExperience] = useState(null);

  const [openDetailModal, setOpenDetailModal] = React.useState(false);
  const handleOpenDetails = (engagementType) => {
    const foundData = dataBrandExperience.find(
      (item) => item.fanEngagementType === engagementType
    );

    setSelectedExperience(foundData);
    setOpenDetailModal(true);
  };

  const handleCloseDetails = () => {
    setOpenDetailModal(false);
  };

  const closeSlider = () => setIsSliderOpen(false);
  const [loading, setLoading] = useState(false);
  const { playerId, teamId } = useParams();

  const navigate = useNavigate();
  const openSlider = (index) => {
    setCurrentIndex(index);
    setIsSliderOpen(true);
  };

  const nextSlide = () => {
    setCurrentIndex(
      (prev) => (prev + 1) % (athleteProfileData?.images?.length || 1)
    );
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prev) =>
        (prev - 1 + (athleteProfileData?.images?.length || 1)) %
        (athleteProfileData?.images?.length || 1)
    );
  };

  // api stuff

  const getPlayerDetails = () => {
    setLoading(true);

    const url = `${APIUrl()}/v1/get_player/${playerId}/${teamId}`;
    const options = {
      method: "GET",
      headers: { "X-API-Key": APIUrlToken() },
    };

    axios(url, options)
      .then((response) => {
        setPlayerDetails(response?.data);
        setPlayerFirstName(response?.data?.player_name?.split(" ")[0]);
        setAthleteProfileData(response?.data?.athlete_profile);
      })
      .catch((error) => {
        console.error("Error fetching player data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getPlayerDetails();
  }, [playerId, teamId]);
  const [pricingOptionsList, setPricingOptionsList] = useState([]);
  const dataBrandExperience = [
    {
      fanEngagementType: "socialMediaPost",
      title: "Sponsored Social Media Post",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Twitch",
        "LinkedIn",
        "Zoom",
        "Virtual-Live",
        "In-Person",
        "Other",
      ],
      description: `${playerFirstName} will promote your product or service with their social media audience on the selected platform. (Boosts awareness, drives traffic/sales)

For example, if Instagram is selected as the platform and the athlete has over 250K followers, your content may be seen by their audience, helping expand your reach.`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.socialMediaPost?.options
        ? pricingOptionsList?.config?.socialMediaPost?.options
        : [
            {
              pricingText: "Under 50 words ($1000)",
              pricingValue: "$1000",
            },
            {
              pricingText: "50–100 words +$1,000",
              pricingValue: "+$1000",
            },
            {
              pricingText: "100–150 words +$1,500",
              pricingValue: "+$1500",
            },
            {
              pricingText: "Under 30 sec ($1000)",
              pricingValue: "$1000",
            },
            {
              pricingText: "30 sec–1 min +$3000",
              pricingValue: "+$3000",
            },
            {
              pricingText: "Over 1 min (inquire)",
              pricingValue: "custom",
            },
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "giveawaysContest",
      title: "Giveaways & Contest",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Twitch",
        "LinkedIn",
        "Zoom",
        "Virtual-Live",
        "In-Person",
        "Other",
      ],
      description: `${playerFirstName} will participate in product/service giveaway & contest with their social media audience on the selected platform. Fans tag friends, follow brand, use hashtags, enter to win. (Viral reach, rapid follower growth)

For example, if Instagram is selected as the platform and the athlete has over 250K followers, your content may be seen by their audience, helping expand your reach.`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.giveawaysContest?.options
        ? pricingOptionsList?.config?.giveawaysContest?.options
        : [
            {
              pricingText:
                "Add-ons: Prize fulfillment (pass-through), extra posts",
              pricingValue: "custom",
            },
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "storeAppearance",
      title: "In-Store Appearance / Pop-Up",
      platforms: ["In-Person", "Virtual-Live", "Zoom", "Other"],
      description: `${playerFirstName} will participate in an in-store appearance or pop-up engagement. Fans attend event, take photos, share online. (Drives foot traffic, local buzz)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.storeAppearance?.options
        ? pricingOptionsList?.config?.storeAppearance?.options
        : [
            {
              pricingText: "15 min ($2500)",
              pricingValue: "$2500",
            },
            {
              pricingText: "30 min +$1,000",
              pricingValue: "+$1000",
            },
            {
              pricingText: "Over 30 min (inquire)",
              pricingValue: "custom",
            },
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "limitedEditionProduct",
      title: "Limited-Edition Product Drop",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Twitch",
        "LinkedIn",
        "Zoom",
        "Virtual-Live",
        "In-Person",
        "Other",
      ],
      description: `${playerFirstName} will participate in a limited-edition product drop engagement. Fans buy exclusive items, post, or unboxing. (Revenue generation, hype marketing)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.limitedEditionProduct?.options
        ? pricingOptionsList?.config?.limitedEditionProduct?.options
        : [
            {
              pricingText: "Rev-share or flat fee (by agreement)",
              pricingValue: "custom",
            },
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "contentSeriesVlog",
      title: "Content Series / Vlog",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Other",
      ],
      description: `${playerFirstName} will participate in a content series or vlog. Fans watch, comment, follow, share, or submit questions. (Deep engagement, brand storytelling)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.contentSeriesVlog?.options
        ? pricingOptionsList?.config?.contentSeriesVlog?.options
        : [
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "livestreamPodcast",
      title: "Livestream / Podcast",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Other",
      ],
      description: `${playerFirstName} will participate in a livestream / podcast engagement. Live chat, subscriptions, Q&A, or polls. (Long‑form attention, authentic voice)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.livestreamPodcast?.options
        ? pricingOptionsList?.config?.livestreamPodcast?.options
        : [
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },

    {
      fanEngagementType: "discountCodesAffiliateLinks",
      title: "Discount Codes / Affiliate Links",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Other",
      ],
      description: `${playerFirstName} will participate in a discount codes on related merch / promoting affiliate links.  Fans use unique codes to shop; track athlete‑specific conversions
(Sales attribution, performance tracking)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.discountCodesAffiliateLinks
        ?.options
        ? pricingOptionsList?.config?.discountCodesAffiliateLinks?.options
        : [
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },

    {
      fanEngagementType: "gameDayPromotion",
      title: "Game Day Promotion",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "In Person",
        "Other",
      ],
      description: `${playerFirstName} will participate in a game day promotion. Fans scan QR codes, redeem offers, join challenges
(Emotional tie‑in with game experience)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.gameDayPromotion?.options
        ? pricingOptionsList?.config?.gameDayPromotion?.options
        : [
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "fanVotingCampaigns",
      title: "Fan Voting Campaigns",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Other",
      ],
      description: `${playerFirstName} will participate in a fan voting campaign. Fans vote in polls or participate in challenges. (Data capture, fan engagement)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.fanVotingCampaigns?.options
        ? pricingOptionsList?.config?.fanVotingCampaigns?.options
        : [
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },

    {
      fanEngagementType: "cameoStyleShoutout",
      title: "Cameo-Style Shoutout",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Other",
      ],
      description: `${playerFirstName} will participate in a cameo-style shoutout. Fans purchase shoutouts or receive sponsored messages. (Direct‑to‑fan, personalized brand connection)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.cameoStyleShoutout?.options
        ? pricingOptionsList?.config?.cameoStyleShoutout?.options
        : [
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "collectiveSponsored",
      title: "Collective-Sponsored Engagement",
      platforms: [
        "Instagram",
        "Facebook",
        "X (Twitter)",
        "YouTube",
        "TikTok",
        "Other",
      ],
      description: `${playerFirstName} will participate in a Collective-Sponsored Engagement. Fans subscribe/donate to collective, attend events, and get perks. (Community goodwill, alignment with school loyalty)`,
      specialInstructionsLabel: "Provide details of engagement:",
      pricingOptions: pricingOptionsList?.config?.collectiveSponsored?.options
        ? pricingOptionsList?.config?.collectiveSponsored?.options
        : [
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
  ];
  const getPricingListOptions = () => {
    const url = `${APIUrl()}/v1/brand_engagement_pricing/by_player/${playerId}`;
    const option = {
      method: "GET",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        const data = response?.data || [];
        setPricingOptionsList(data);
        // window.location.href = data
      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };
  useEffect(() => {
    getPricingListOptions();
  }, []);
  const getUsername = (url) => {
    if (!url) return "";
    return url.split(".com/")[1] || url; // fallback if format is different
  };
  const socials = [
    {
      icon: <FiInstagram />,
      url: playerDetails?.athlete_profile?.instagram_url,
    },
    {
      icon: <CiFacebook />,
      url: playerDetails?.athlete_profile?.facebook_url,
    },
    {
      icon: <FiYoutube />,
      url: playerDetails?.athlete_profile?.youtube_url,
    },
    {
      icon: <FiTwitter />,
      url: playerDetails?.athlete_profile?.twitter_url,
    },
    {
      icon: <AiOutlineTikTok />,
      url: playerDetails?.athlete_profile?.tiktok_url,
    },
  ];
  return (
    <div>
      {loading ? <Loader /> : null}

      <div className="arrow-go-back-fan">
        <p onClick={() => navigate("/dashboard/start-your-brand-partnership")}>
          <IoIosArrowRoundBack />
        </p>
        <p
          className="go-back-fan"
          onClick={() => navigate("/dashboard/start-your-brand-partnership")}
        >
          Go Back
        </p>
      </div>
      <div
        className={
          athleteProfileData?.images
            ? "image-section-fan-experience"
            : "image-section-fan-experience-none"
        }
      >
        {(() => {
          const imageArray = Array.isArray(athleteProfileData?.images)
            ? athleteProfileData.images
            : athleteProfileData?.images
            ? [athleteProfileData.images]
            : [];

          return imageArray.length > 0
            ? imageArray
                .slice(0, 5)
                .map((img, i) => (
                  <img
                    key={i}
                    src={`data:image/jpeg;base64,${img}`}
                    alt={`fan-img-${i}`}
                    onClick={() => openSlider(i)}
                    className="fan-gallery-img"
                  />
                ))
            : "";
          // <p className="no-image-available">No image available</p>
        })()}

        {/* Show "View all" button only if more than 5 images exist */}
        {Array.isArray(athleteProfileData?.images) &&
          athleteProfileData.images.length > 5 && (
            <button
              className="view-all-btn-fan-ex"
              onClick={() => openSlider(0)}
            >
              View all
            </button>
          )}
      </div>

      {/* ✅ Image Slider */}
      {isSliderOpen && (
        <div className="fan-slider-overlay">
          {(() => {
            const imageArray = Array.isArray(athleteProfileData?.images)
              ? athleteProfileData.images
              : athleteProfileData?.images
              ? [athleteProfileData.images]
              : [];

            return (
              <>
                {/* Progress bar container */}
                <div className="fan-progress-bar-container">
                  {imageArray.map((_, index) => (
                    <div
                      key={index}
                      className={`fan-progress-segment ${
                        index === currentIndex
                          ? "fan-progress-active"
                          : index < currentIndex
                          ? "fan-progress-completed"
                          : ""
                      }`}
                    ></div>
                  ))}
                </div>

                <button onClick={closeSlider} className="close-btn-fan">
                  <RxCross1 size={32} />
                </button>

                <button onClick={prevSlide} className="prev-btn-fan">
                  <IoIosArrowRoundBack size={48} />
                </button>

                <img
                  src={`data:image/jpeg;base64,${imageArray[currentIndex]}`}
                  alt="fan-slider"
                  className="fan-slider-img"
                />

                <button onClick={nextSlide} className="next-btn-fan">
                  <IoIosArrowRoundForward size={48} />
                </button>
              </>
            );
          })()}
        </div>
      )}
      <div className="for-all-info-fan-experience">
        <div className="for-details-fan-experience">
          <div className="for-details-fan-experience-inner">
            <div className="profile-image-fan-experience">
              <img
                className="profile-image-fan-experience-inner"
                src={playerDetails?.image_url}
                alt=""
              />
            </div>
            <div className="name-deatils-fan-experience">
              <p className="name-deatils-fan-experience-inner">
                {playerDetails?.player_name}
              </p>
              <p className="player-sport-fan-ex">
                {playerDetails?.team_name ? playerDetails?.team_name : ""}
                {playerDetails?.sport_name
                  ? ` • ${playerDetails.sport_name}`
                  : ""}

                {playerDetails?.position ? ` • ${playerDetails.position}` : ""}
                {playerDetails?.jersey_number
                  ? ` • #${playerDetails.jersey_number}`
                  : ""}
              </p>
              <div className="player-sport-fan-ex-links-main">
                {socials
                  .filter((item) => item.url) // remove empty urls
                  .map((item, index) => {
                    const username = getUsername(item.url);

                    return (
                      <p className="player-sport-fan-ex-links" key={index}>
                        {item.icon}
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="social-link"
                        >
                          {username}
                        </a>
                      </p>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="about-section-start-dan-ex">
            <p className="about-section-start-dan-ex-inner">
              Athlete's Profile
            </p>
            <div className="main-icon-and-detail-ex">
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <TiHomeOutline />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">Hometown:</p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.hometown}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <IoSchoolOutline />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    High School:{" "}
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.high_school}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <LuSchool />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    Previous School:{" "}
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.previous_school}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <CiCircleInfo />
                </div>

                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    Summary (Bio):{" "}
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.summary}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <PiMedalLight />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    Accolades & Awards:
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.accolades}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <IoLocationOutline />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    Preferred Locations:
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {/* {athleteProfileData?.location} */}
                    {/* {athleteProfileData?.preferred_locations} */}
                    {athleteProfileData?.preferred_locations?.map(
                      (loc, index) => (
                        <span key={index}>
                          {loc} <br />
                        </span>
                      )
                    )}
                  </p>
                </div>
              </div>{" "}
            </div>
          </div>

          <div className="about-section-start-outer">
            <p className="about-section-start-dan-ex-inner">
              Interests / Hobbies
            </p>
            <div className="main-icon-and-detail-ex">
              <div className="Interests-elements-container">
                {athleteProfileData?.interests?.length > 0 ? (
                  athleteProfileData.interests.map((interest, index) => (
                    <p key={index}>
                      <CiCircleCheck /> {interest}
                    </p>
                  ))
                ) : (
                  <p>No Interests / Hobbies available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="for-personal-detail-fan-experience">
          <p className="for-personal-use-heading">
            Select the engagement option from the available services below:
          </p>
          <p className="for-personal-use-heading-new">
            (for commercial use only)
          </p>
          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <TbSpeakerphone />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Sponsored Social Media Post{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("socialMediaPost")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {pricingOptionsList?.config?.socialMediaPost
                      ?.sectionValue || defaultValueFan[0]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} posts or promotes a product or service
                  </p>
                </div>
              </div>

              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Sponsored Social Media Post",
                      type: "socialMediaPost",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      pricingOptionsList: pricingOptionsList,
                      sectionValue:
                        pricingOptionsList?.config?.socialMediaPost
                          ?.sectionValue || defaultValueFan[0],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <IoNewspaperOutline />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Giveaways & Contest{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("giveawaysContest")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.giveawaysContest
                      ?.sectionValue || defaultValueFan[1]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} announces brand associated contest,
                    possibly tied to performance or milestones
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Giveaways & Contest",
                      type: "giveawaysContest",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.giveawaysContest
                          ?.sectionValue || defaultValueFan[1],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <FaRegEye />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    In-Store Appearance / Pop-Up{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("storeAppearance")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.storeAppearance
                      ?.sectionValue || defaultValueFan[2]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} is compensated for time, promotion, and
                    social content
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "In-Store Appearance / Pop-Up",
                      type: "storeAppearance",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.storeAppearance
                          ?.sectionValue || defaultValueFan[2],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <LuBookUser />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Limited-Edition Product Drop{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("limitedEditionProduct")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.limitedEditionProduct
                      ?.sectionValue || defaultValueFan[3]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    NIL rights used on merch {playerFirstName} promotes drop
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Limited-Edition Product Drop",
                      type: "limitedEditionProduct",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.limitedEditionProduct
                          ?.sectionValue || defaultValueFan[3],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <PiPencilDuotone />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Content Series / Vlog{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("contentSeriesVlog")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.contentSeriesVlog
                      ?.sectionValue || defaultValueFan[4]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} features brand organically in lifestyle or
                    training content
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Content Series / Vlog",
                      type: "contentSeriesVlog",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.contentSeriesVlog
                          ?.sectionValue || defaultValueFan[4],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <FaPodcast />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Livestream / Podcast{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("livestreamPodcast")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.livestreamPodcast
                      ?.sectionValue || defaultValueFan[5]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    Sponsored segments or {playerFirstName} hosting shows
                    featuring brand messaging
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Livestream / Podcast",
                      type: "livestreamPodcast",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.livestreamPodcast
                          ?.sectionValue || defaultValueFan[5],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <HiOutlineLinkSlash />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Discount Codes / Affiliate Links{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() =>
                        handleOpenDetails("discountCodesAffiliateLinks")
                      }
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.discountCodesAffiliateLinks
                      ?.sectionValue || defaultValueFan[6]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} receives flat rate or % commission
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Discount Codes / Affiliate Links",
                      type: "discountCodesAffiliateLinks",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.discountCodesAffiliateLinks
                          ?.sectionValue || defaultValueFan[6],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <MdGamepad />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Game Day Promotion{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("gameDayPromotion")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.gameDayPromotion
                      ?.sectionValue || defaultValueFan[7]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} promotes in-game deal or brand backs
                    collective
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Game Day Promotion",
                      type: "gameDayPromotion",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.gameDayPromotion
                          ?.sectionValue || defaultValueFan[7],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <TbBrandCampaignmonitor />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Fan Voting Campaigns{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("fanVotingCampaigns")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.fanVotingCampaigns
                      ?.sectionValue || defaultValueFan[8]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} interacts with fans vote on brand
                    featuring -shoes, meals, slogans, etc.
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Fan Voting Campaigns",
                      type: "fanVotingCampaigns",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.fanVotingCampaigns
                          ?.sectionValue || defaultValueFan[8],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <TiFlashOutline />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Cameo-Style Shoutout{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("cameoStyleShoutout")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.cameoStyleShoutout
                      ?.sectionValue || defaultValueFan[9]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    Brand may sponsor shoutout content or reward top customers
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Cameo-Style Shoutout",
                      type: "cameoStyleShoutout",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.cameoStyleShoutout
                          ?.sectionValue || defaultValueFan[9],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>

          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <SiOpencollective />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Collective-Sponsored Engagement{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("collectiveSponsored")}
                    >
                      More Details
                    </span>
                  </p>
                  <p className="inner-text-personal-ex-second">
                    {" "}
                    {pricingOptionsList?.config?.collectiveSponsored
                      ?.sectionValue || defaultValueFan[10]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    Brand funds collective in exchange for ongoing promotional
                    access
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/BrandPartnershipType", {
                    state: {
                      dataBrandExperience: dataBrandExperience,
                      checkoutType: "Collective-Sponsored Engagement",
                      type: "collectiveSponsored",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      sectionValue:
                        pricingOptionsList?.config?.collectiveSponsored
                          ?.sectionValue || defaultValueFan[10],
                    },
                  })
                }
              >
                Start your Brand Partnership
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal open={openDetailModal} onClose={handleCloseDetails}>
        <Box sx={style}>
          <Typography variant="h6">{selectedExperience?.title}</Typography>

          <Typography sx={{ mt: 2 }}>
            <div
              className="fan-description"
              dangerouslySetInnerHTML={{
                __html: selectedExperience?.description?.replace(
                  /\n/g,
                  "<br/>"
                ),
              }}
            />
          </Typography>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              className="engagement-modal-close-btn"
              onClick={handleCloseDetails}
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default BrandPartnershipComponent;
